import { render, staticRenderFns } from "./CustomerSelector.vue?vue&type=template&id=288eb7fc"
import script from "./CustomerSelector.vue?vue&type=script&lang=ts"
export * from "./CustomerSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports